<button style="float:right;" class="btn btn-primary " type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>{{ 'texto_60' | translate }}
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <!--Content-->
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 style="margin-bottom: 0px;" class="card-title">{{ 'texto_378' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <div class="md-form mb-3">
          <input type="text" id="orangeForm-email" class="form-control" [formControl]="signupFormModalId" mdbInput
            mdbValidate>
          <label for="orangeForm-email">ID. {{ 'texto_156' | translate }}</label>
          <mdb-error *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">{{
            'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">{{
            'texto_62' | translate }}
          </mdb-success>
        </div>

        <div class="md-form mb-3">
          <input type="text" id="orangeForm-name" class="form-control" [formControl]="signupFormModalName" mdbInput
            mdbValidate maxlength="255">
          <label for="orangeForm-name">N. {{ 'texto_156' | translate }}</label>
          <mdb-error *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <div class="md-form col-md-12">
          <label for="form-email">{{ 'texto_46' | translate }}</label>
          <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 20%;"></mdb-icon>
          <textarea maxlength="4000" type="text" id="form107Modal" class="md-textarea form-control" rows="5" mdbInput
            [formControl]="contactFormModalMessage"></textarea>
          <mdb-error
            *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success
            *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>

        </div>
      </div>


      <div class="text-center mt-3">
        <button (click)="addMedidaCautelar()" rounded="true" class="btn-primary mt-1 waves-light btn-rounded btn"
          mdbWavesEffect>{{ 'texto_60' | translate }}
        </button>
      </div>

    </div>
    <!--/.Content-->
  </div>
</div>